/** Etempa Web Solutions */

const anchorLinkTargetArray = window.location.href.split('#');
const header = document.getElementById('shopify-section-header');

let anchorLinkTarget;
let anchorLinkElem;
let headerHeight;

scrollToAnchor();
attachWindowEvents();
attachAnchorEvents();

function scrollToAnchor() {
    if (anchorLinkTargetArray && anchorLinkTargetArray.length > 1) {
        anchorLinkTarget = anchorLinkTargetArray[1].trim();
        scrollToAnchorLinkElem(anchorLinkTarget);
    }
}

function getHeaderHeight() {
    headerHeight = Number(header.getBoundingClientRect().height);
}

function getElementY(elem) {
    return Number(elem.getBoundingClientRect().top + window.scrollY - headerHeight);
}

function scrollToAnchorLinkElem(anchorLinkTarget) {
    anchorLinkElem = document.getElementById(anchorLinkTarget);
    if (anchorLinkElem) {
        getHeaderHeight();
        window.scrollTo(0, getElementY(anchorLinkElem), "smooth");
    }
}

function attachWindowEvents() {
    window.addEventListener('scroll', scrollToAnchor);

    window.addEventListener('wheel', function(e){
        window.removeEventListener('scroll', scrollToAnchor);
    });
    window.addEventListener('drag', function(e){
        window.removeEventListener('scroll', scrollToAnchor);
    });
    window.addEventListener('touchmove', function(e){
        window.removeEventListener('scroll', scrollToAnchor);
    });
}

function attachAnchorEvents() {
    let anchorLinks = document.querySelectorAll('a[href^="#"]');
    if (anchorLinks && anchorLinks.length > 0) {
        anchorLinks.forEach((link)=>{
            link.addEventListener('click', (e)=>{
                e.preventDefault();
                scrollToAnchorLinkElem(link.getAttribute('href')?.replace('/','').replace('#','').trim());
            });
        });
    }
}



